export default __webpack_public_path__ + "static/media/old_college_brewery.d7ae2304.png";